<section class="static-page">
  <header class="static-header">
    <span class="static-icon" aria-hidden="true"><i class="fa-solid fa-newspaper"></i></span>
    <h1>Blog</h1>
    <p class="static-subtitle">Product updates, guides, and notes from the orderYaa team.</p>
  </header>

  <div class="container">
    <div class="static-content">
      <p>
        This is where we'll share product updates, how-to guides, and lessons learned from
        building an ERP for real, day-to-day businesses.
      </p>

      <h2>What we'll cover</h2>
      <ul>
        <li>New feature announcements and release notes</li>
        <li>Setup guides for inventory, accounting, and manufacturing</li>
        <li>Practical tips for running retail, restaurant, and wholesale operations</li>
      </ul>

      <h2>Coming soon</h2>
      <p>
        We don't have posts published yet. Check back soon, or follow our
        <a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">LinkedIn</a>
        page for updates in the meantime.
      </p>
    </div>
  </div>
</section>
